export default {
  namespaced: true,
  state: {
    // weixin
    code: null,
    sid: null,

    // ranch
    user: null,

    // dartcome
    me: null,

    addTimerJob: []
  },
  mutations: {
    code (state, payload) { state.code = payload },
    sid (state, payload) { state.sid = payload },
    user (state, payload) { state.user = payload },
    me (state, payload) { state.me = payload }
  },
  actions: {
    async wxLogin ({commit, dispatch}, {code}) {
      commit('code', code)
      commit('sid', code)

      // '登录中...'
      let user = await dispatch('api/ranch/userSignIn', {uid: code}, {root: true})
      commit('user', user)
      return user
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/me/index.js